<template>
  <button
    type="button"
    @click="handleClick"
    class="group inline-flex items-center gap-1 text-[18px] font-medium text-bodyText dark:text-foreground transition-colors"
  >
    <span
      class="inline-flex items-center justify-center w-10 h-10 rounded-full transition-colors"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.9993 29.333C8.65268 29.333 2.66602 23.3463 2.66602 15.9997C2.66602 8.65301 8.65268 2.66634 15.9993 2.66634C23.346 2.66634 29.3327 8.65301 29.3327 15.9997C29.3327 23.3463 23.346 29.333 15.9993 29.333ZM18.386 11.9997C18.7727 11.613 18.7727 10.973 18.386 10.5863C18.186 10.3863 17.9327 10.293 17.6793 10.293C17.426 10.293 17.1727 10.3863 16.9727 10.5863L12.266 15.293C11.8793 15.6797 11.8793 16.3197 12.266 16.7063L16.9727 21.413C17.3593 21.7997 17.9993 21.7997 18.386 21.413C18.7727 21.0263 18.7727 20.3863 18.386 19.9997L14.386 15.9997L18.386 11.9997Z"
          fill="currentColor"
        />
      </svg>
    </span>
    <span :class="{ 'hidden sm:inline': hideTextOnMobile }">Back</span>
  </button>
</template>

<script>
export default {
  name: "BackButton",
  props: {
    hideTextOnMobile: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      // If the parent component is listening for @click, let it handle it.
      // Otherwise, perform a standard router back navigation.
      if (this.$attrs.onClick) {
        this.$emit("click");
      } else {
        this.$router.back();
      }
    },
  },
};
</script>

<style scoped></style>
